/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Meine bevorzugten Routen`
};

const en_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Find my favourite routes`
};

const es_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Acceder a mis itinerarios favoritos`
};

const fr_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Retrouver mes itinéraires favoris`
};

const it_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Vai ai tuoi itinerari preferiti`
};

const nl_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn favoriete routes`
};

const pt_bookmark__find_favorites_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Encontrar os meus itinerários favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__find_favorites_routes = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__find_favorites_routes(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__find_favorites_routes", locale)
	if (locale === "de") return de_bookmark__find_favorites_routes(inputs)
	if (locale === "en") return en_bookmark__find_favorites_routes(inputs)
	if (locale === "es") return es_bookmark__find_favorites_routes(inputs)
	if (locale === "fr") return fr_bookmark__find_favorites_routes(inputs)
	if (locale === "it") return it_bookmark__find_favorites_routes(inputs)
	if (locale === "nl") return nl_bookmark__find_favorites_routes(inputs)
	return pt_bookmark__find_favorites_routes(inputs)
};